// @ts-strict-ignore
import {PlayerMapping, RecorderMapping, TrainingRoom, VogMode} from "@models";
import {Component, Injector, OnInit} from "@angular/core";
import {SimSystemExtendedService, NotificationService, SimTrainingRoomService, SimMaterialDialogService} from "@services";

import {
	BasicMaterialDialog,
	MatDialogDataBaseInput,
	MatDialogDataBaseOutput,
} from "../../basic-material-dialog/basic-material-dialog.directive";
import {Translations} from "@translations";
import {TranslateService} from "@ngx-translate/core";

export interface RECORDER_MAPPINGS_CONFIGURATION_DIALOG_INPUT extends MatDialogDataBaseInput {
	recorderMapping: RecorderMapping;
}

export interface RECORDER_MAPPINGS_CONFIGURATION_DIALOG_OUTPUT extends MatDialogDataBaseOutput {
	updatedRecorderMapping: RecorderMapping;
}

@Component({
	selector: "sim-recorder-mappings-configuration-dialog",
	templateUrl: "./recorder-mappings-configuration-dialog.component.html",
	styleUrls: ["./recorder-mappings-configuration-dialog.component.scss"],
	standalone: false,
})
export class RecorderMappingsConfigurationDialogComponent
	extends BasicMaterialDialog<
		RecorderMappingsConfigurationDialogComponent,
		RECORDER_MAPPINGS_CONFIGURATION_DIALOG_INPUT,
		RECORDER_MAPPINGS_CONFIGURATION_DIALOG_OUTPUT
	>
	implements OnInit
{
	T = Translations;

	public hidePassword = true;
	public vogModes: {name: string; value: VogMode}[] = null;
	public players: PlayerMapping[];
	public trainingRooms: TrainingRoom[];

	constructor(
		private _simSystemService: SimSystemExtendedService,
		private _simNotificationService: NotificationService,
		private _simTrainingRoomService: SimTrainingRoomService,
		private translate: TranslateService,
		private SimDialogService: SimMaterialDialogService,
		private SimNotificationService: NotificationService,
		_injector: Injector,
	) {
		super(_injector);
	}

	private updateAllReorderTask: Promise<any> = null;
	ngOnInit() {
		super.ngOnInit();
		this.init();
	}

	protected init() {
		this.initializeVogModes();
		this.initializePlayers();
		this.initializeTrainingRooms();
	}

	public saveRecorderMapping() {
		this.close({
			action: "ok",
			updatedRecorderMapping: this.data.recorderMapping,
		});
	}
	private initializeVogModes() {
		this.vogModes = [
			{name: "Automatic", value: VogMode.Automatic},
			{name: "UserControlled", value: VogMode.UserControlled},
		];
	}

	private initializePlayers() {
		this._simSystemService.getPlayerMappings().then((loadPlayerMappingsResult) => {
			if (loadPlayerMappingsResult) {
				this.players = loadPlayerMappingsResult;
			}
		});
	}

	private initializeTrainingRooms() {
		this._simTrainingRoomService.getTrainingRooms().then((getTrainingRoomsResult) => {
			if (getTrainingRoomsResult) {
				this.trainingRooms = getTrainingRoomsResult;
			}
		});
	}

	public isSelectedPlayer(playerMappingId: string) {
		if (this.data.recorderMapping.selectedPlayerIds && playerMappingId) {
			return this.data.recorderMapping.selectedPlayerIds.indexOf(playerMappingId) >= 0;
		}

		return false;
	}

	public toggleSelectedPlayer(playerMappingId: string) {
		if (this.data.recorderMapping.selectedPlayerIds) {
			const selectedPlayerIndex = this.data.recorderMapping.selectedPlayerIds.indexOf(playerMappingId);

			if (selectedPlayerIndex >= 0) {
				this.data.recorderMapping.selectedPlayerIds.splice(selectedPlayerIndex, 1);
			} else {
				this.data.recorderMapping.selectedPlayerIds.push(playerMappingId);
			}
		} else {
			this.data.recorderMapping.selectedPlayerIds = [playerMappingId];
		}
	}

	public async findMacAddressForRecorder(ip: string) {
		if (!ip) {
			return;
		}
		const macAddressResult = await this._simSystemService.getMacAddress(ip);
		if (macAddressResult) {
			this.data.recorderMapping.macAddress = macAddressResult;
		} else {
			this._simNotificationService.notifyError(
				this.translate.instant(this.T.RECORDER_MAPPING_CONFIGURATION_DIALOG_COULD_NOT_FIND_MAC_ADDRESS),
			);
		}
	}

	public saveForAll() {
		this.SimDialogService.openConfirmationDialog({
			title: this.translate.instant(this.T.RECORDER_MAPPING_CONFIGURATION_CHANGE_ALL_PLAYER_CREDENTIALS),
			description: this.translate.instant(this.T.RECORDER_MAPPING_CONFIGURATION_WANT_TO_APPLY_CREDENTIALS_TO_ALL_PLAYERS),
			okText: this.translate.instant(this.T.ABSTRACT_VIEW_LIST_YES),
			cancelText: this.translate.instant(this.T.SCENARIO_DELETE_DIALOG_CANCEL),
		}).then((result) => {
			if (result.action == "ok") {
				this.updateAllReorderTask = this._simSystemService
					.updateAllRecorderMappingCredentials({
						userName: this.data.recorderMapping.deviceUsername,
						password: this.data.recorderMapping.devicePassword,
						subnetMask: this.data.recorderMapping.subnetMask,
					})
					.then(
						(result) => {},
						(err) => {
							this.SimNotificationService.notifyError(
								this.translate.instant(this.T.RECORDER_MAPPING_CONFIGURATION_WANT_TO_APPLY_CREDENTIALS_TO_ALL_PLAYERS),
							);
						},
					);
			}
		});
	}
}
